import React, {useEffect} from 'react'
import styles from './CrewReviewPage.module.css'

import axios from "axios";
import LoadingBackdrop from "../../../../components/common/LoadingBackdrop";
import {
    Alert, AlertColor,
    Container, Grid, MenuItem, Select, SelectChangeEvent, Tab, Tabs,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {GridCellParams, GridColDef} from "@mui/x-data-grid-pro";
import {Button} from "@material-ui/core";
import SignatureCanvas from 'react-signature-canvas'
import PaystubPage from "./PaystubPage";

const CrewReviewPage = (params) => {
    const [tabSel, setTabSel] = React.useState<number>(0)
    const [selectionModel, setSelectionModel] = React.useState([])
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [snackbarOpen, setSnackbarOpen] = React.useState<{ open: boolean, message: string, type: AlertColor }>({ open: false, message: '', type: 'success' })
    const [timeEntryGridSetting, setTimeEntryGridSettings] = React.useState({timeentrylist: [], fieldlist: [], foremanlist: [], weekendlist:  [], buttontitle: ''})
    const [timeEntryGridColumns, setTimeEntryGridColumns] = React.useState<any[]>([])
    const [activeForeman, setActiveForeman] = React.useState('');
    const [activeWeekend, setActiveWeekend] = React.useState('');
    const crewSignature = React.useRef() as React.MutableRefObject<any>

    useEffect(() => {
        params.setTitle('')
        getGridData()
    }, [])

    const getFieldFormatted = (value) => {
        if (typeof value == "boolean") {
            return value == true ? 'Yes' : 'No'
        }
        else {
            return value
        }
    }

    const getGridData = () => {
        setLoadingBackdrop(true)
        axios.post(`fieldsystemtimereviewcrew`, {}).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            params.setTitle(parsedResponse.pagetitle)
            debugger
            const newTimeEntryList = parsedResponse?.timeentrylist.map(tel => {
                if (tel?.timeentryapproved) {

                }
                return {...tel, id: tel.timeentryid}
            })


            const newTimeColumns = parsedResponse?.fieldlist?.map(fl => {
                return {
                    field: fl.schedulefield,
                    type: 'string', // use schedulefieldcontrol which  is  a number of control type
                    headerName: fl.schedulefieldlabel,
                    width: fl.width,
                    align: fl.align,
                    headerAlign: fl.headeralign,
                    valueFormatter: (value: any, row, column, apiRef) => {
                        return getFieldFormatted(value.value)
                    }
                }
            })
            //
            setTimeEntryGridColumns(prevState => {
                return newTimeColumns
            })
            setTimeEntryGridSettings({...parsedResponse, timeentrylist: newTimeEntryList})

            const selectedModelTemp = newTimeEntryList.filter(item => item.timeentryapproved == true)
            const selected = selectedModelTemp.map(item => {return item.id})
            setSelectionModel(selected)
            setActiveForeman(parsedResponse?.selectedforemanid)
            setActiveWeekend(parsedResponse?.selectedweekend)
            setLoadingBackdrop(false)
        })
    }

    const reloadGridData = (foremanid, weekendid) => {
        setLoadingBackdrop(true)
        axios.post(`fieldsystemtimereviewcrew`, {foremanid: foremanid, weekend: weekendid}).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            params.setTitle(parsedResponse.pagetitle)
            debugger
            const newTimeEntryList = parsedResponse?.timeentrylist.map(tel => {
                if (tel?.timeentryapproved) {

                }
                return {...tel, id: tel.timeentryid}
            })


            const newTimeColumns = parsedResponse?.fieldlist?.map(fl => {
                return {
                    field: fl.schedulefield,
                    type: 'string', // use schedulefieldcontrol which  is  a number of control type
                    headerName: fl.schedulefieldlabel,
                    width: fl.width,
                    align: fl.align,
                    headerAlign: fl.headeralign,
                }
            })
            //
            setTimeEntryGridColumns(prevState => {
                return newTimeColumns
            })
            setTimeEntryGridSettings({...parsedResponse, timeentrylist: newTimeEntryList})

            const selectedModelTemp = newTimeEntryList.filter(item => item.timeentryapproved == true)
            const selected = selectedModelTemp.map(item => {return item.id})
            setSelectionModel(selected)
            setActiveForeman(parsedResponse?.selectedforemanid)
            setActiveWeekend(parsedResponse?.selectedweekend)
            setLoadingBackdrop(false)
        })
    }

    const disableApprove = () => {
        var disable = true
        if (selectionModel && selectionModel?.length > 0) {
            selectionModel.map(selId => {
                const itemFound = timeEntryGridSetting?.timeentrylist?.find(item => item.timeentryapproved == false && item.id == selId)
                debugger
                if (itemFound) {
                    disable = false
                }
            })
        }
        return disable
    }

    const submitReview = () => {
        const body = {
            "foremanid": activeForeman,
            "weekend": activeWeekend,
            "timeentryids": selectionModel.join(', '),
            "signature": crewSignature.current.getTrimmedCanvas().toDataURL('image/png').split(';base64,')[1],
        }
        axios.put(`fieldsystemtimereviewcrew`, body).then((response) => {
            const parsedData = JSON.parse(response.data.jsonString)
            reloadGridData(activeForeman, activeWeekend)
            crewSignature.current.clear()
            setSnackbarOpen({ open: true, message: 'Approved', type: 'success' });
        })
    }


    useEffect(() => {
        if (params.setDisplayTimeEntry) {
            params.setBackArrow('timeentry')
        }
    }, [params.backArrowClick])

    const handleForemanChange = (event: SelectChangeEvent) => {
        setActiveForeman(event.target.value)
        reloadGridData(event.target.value, activeWeekend)
    }

    const getForemanOptions = () => {
        const menuItemsToAdd = timeEntryGridSetting?.foremanlist?.map(item => (
            <MenuItem key={item.foremanid} value={item.foremanid}>
                {item.foremaninfo}
            </MenuItem>
        ))
        return [
            ...menuItemsToAdd
        ]
    }

    const handleWeekendChange = (event: SelectChangeEvent) => {
        setActiveWeekend(event.target.value)
        reloadGridData(activeForeman, event.target.value)
    }

    const getWeekendOptions = () => {
        const menuItemsToAdd = timeEntryGridSetting?.weekendlist?.map(item => (
            <MenuItem key={item.weekend} value={item.weekend}>
                {item.weekendinfo}
            </MenuItem>
        ))
        return [
            ...menuItemsToAdd
        ]
    }
    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        // if (reason === 'clickaway') {
        //     return;
        // }

        setSnackbarOpen({ open: false, message: "", type: 'success' });
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabSel(newValue)
    }

    const clearSignaturePad = () => {
        crewSignature.current.clear()
        // currentSig.base64Data = ""
    }

    const data = [{"id": 1, "employeename":"Dan","mo_st":1,"mo_ot":1,"mo_dt":1,"mo_pd":1,"mo_mhr":1,"mo_mdl":1,"tu_st":2,"tu_ot":2,"tu_dt":2,"tu_pd":2,"tu_mhr":2,"tu_mdl":2,"we_st":3,"we_ot":3,"we_dt":3,"we_pd":3,"we_mhr":3,"we_mdl":3,"th_st":4,"th_ot":4,"th_dt":4,"th_pd":4,"th_mhr":4,"th_mdl":4,"fi_st":5,"fi_ot":5,"fi_dt":5,"fi_pd":5,"fi_mhr":5,"fi_mdl":5,"sa_st":6,"sa_ot":6,"sa_dt":6,"sa_pd":6,"sa_mhr":6,"sa_mdl":6,"su_st":7,"su_ot":7,"su_dt":7,"su_pd":7,"su_mhr":7,"su_mdl":7,"to_st":28,"to_ot":28,"to_dt":28,"to_pd":28,"to_mhr":28,"to_mdl":28}]

    const columnGroupingModel = [
        {
            groupId: 'Internal',
            description: '',
            children: [{ field: 'id' }],
        },
        {
            groupId: 'Basic info',
            children: [
                {
                    groupId: 'Monday',
                    children: [{ field: 'mo_st' }, { field: 'mo_ot' }],
                },
                { field: 'age' },
            ],
        },
    ];

    const paycheckColumnDefs: GridColDef[] = [
        {
            field: 'employeename',
            type: 'string',
            headerName: 'Employee',
            width: 125,
            align: "left",
            headerAlign: "left"
        },
        {
            field: 'mo_st',
            type: 'string',
            headerName: 'mo_st',
            width: 25,
            align: "left",
            headerAlign: "left"
        },
        {
            field: 'mo_ot',
            type: 'string',
            headerName: 'mo_ot',
            width: 25,
            align: "left",
            headerAlign: "left"
        }
    ]


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            {snackbarOpen.open &&
                <Snackbar
                    open={true}
                    autoHideDuration={4000}
                    onClose={handleClose}
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                >
                    <Alert severity={snackbarOpen.type}>
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            }
            {/*<div hidden={params.displayFileViewer}>*/}
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Container style={{width: '100%'}}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-begin"
                            alignItems="center"
                        >
                            <Grid item xs={12} padding={0} spacing={0}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-begin"
                                    alignItems="center"
                                >
                                    <Grid item xs={6} padding={1} spacing={1}>
                                        <Select
                                            onChange={handleForemanChange}
                                            style={{ width: '100%', height:'30px' }}
                                            value={activeForeman}
                                        >
                                            {getForemanOptions()}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6} padding={1} spacing={1}>
                                        <Select
                                            onChange={handleWeekendChange}
                                            style={{ width: '100%', height:'30px' }}
                                            value={activeWeekend}
                                        >
                                            {getWeekendOptions()}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    <Tabs
                        value={tabSel}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab value={0} label={'Time Clock'}></Tab>
                        <Tab value={1} label={'Pay Stub'}></Tab>
                    </Tabs>

                        {tabSel == 0 && timeEntryGridColumns?.length > 0 &&
                            <>
                                <DataGridPremium
                                    rows={timeEntryGridSetting?.timeentrylist}
                                    columns={timeEntryGridColumns}
                                    autoHeight={true}
                                    density={'compact'}
                                    pageSize={25}
                                    loading={loadingBackdrop}
                                    disableMultipleSelection={true}
                                    checkboxSelection
                                    selectionModel={selectionModel}
                                    onSelectionModelChange={(newSelectionModel) => {
                                        setSelectionModel(newSelectionModel);
                                    }}
                                    isRowSelectable={(params) => params.row.timeentryapproved == false}

                                />
                                <div style={{
                                    // display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    // gap: '10px',
                                    // paddingBottom: '20px',
                                    paddingTop: '20px',
                                }}>
                                    <SignatureCanvas
                                        ref={crewSignature}
                                        clearOnResize={false}
                                        canvasProps={{className: styles.sigPad}}
                                        // onEnd={async () => {
                                        //     const signCanvasFile = dataURLtoFile(sigReference?.current?.getTrimmedCanvas().toDataURL('image/png'), controlName)
                                        //     const fileReader = new FileReader()
                                        //     fileReader.onloadend = function (event) {}
                                        //     fileReader.onload = function (event) {
                                        //         const data = event.target.result as string
                                        //         const dataSpit = data.split(';base64,')[1]
                                        //         setSignatureImageData(controlName, controlData, dataSpit)
                                        //     }
                                        //
                                        //     new Compressor(signCanvasFile, {
                                        //         quality: 0.4,
                                        //         success(result) {
                                        //             fileReader.readAsDataURL(result)
                                        //         },
                                        //         error(err) {
                                        //             console.log(err.message);
                                        //         },
                                        //     });
                                        // }}
                                        // value={value}
                                    />
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    paddingBottom: '10px',
                                    paddingTop: '10px',
                                }}>
                                    <button type="button" name={'clear'} className={styles.buttons} onClick={() => {clearSignaturePad()}}>
                                        Clear
                                    </button>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    paddingBottom: '20px',
                                    // paddingTop: '20px',
                                }}>
                                    <Button disabled={disableApprove()} onClick={(e) => submitReview()} variant="contained"  className={styles.submitButton} type="submit" form={'time-clock-dynamic-form'}>
                                        {timeEntryGridSetting?.buttontitle}
                                    </Button>
                                </div>
                            </>
                        }
                        {tabSel == 1 && timeEntryGridColumns?.length > 0 &&
                            <PaystubPage formanid={activeForeman} weekend={activeWeekend} />
                        }
                    </Container>
                </div>
            {/*</div>*/}
        </div>
    )
}

export default CrewReviewPage